if (!customElements.get('sc-expedition-preorder-label')) {
  customElements.define('sc-expedition-preorder-label', class extends HTMLElement {
    connectedCallback() {
      const root = this.closest('product-info');
      if (!root) return;
      this.update = () => {
        root.querySelectorAll('.rez-preorder-featured-btn').forEach(button => {
          if (!button.disabled && button.textContent.trim() !== this.dataset.label) {
            button.textContent = this.dataset.label;
          }
        });
      };
      this.observer = new MutationObserver(this.update);
      this.observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
